import { Provider } from '@angular/core';
import { ProductsService, UserService } from 'shared-data-access';
import { CountryCode, JourneyConfig, JourneyConfigState, JourneyConfigToken } from 'shared-utils';

export const journeyStateProvider: Provider = {
  provide: JourneyConfigToken,
  useFactory: (userService: UserService, productsService: ProductsService): JourneyConfig => {
    return {
      get state(): JourneyConfigState {
        return {
          country: userService.getCountry() as CountryCode,
          language: userService.getLanguage(),
          providerId: userService.getProvider().providerId,
          product: productsService.selectedProduct,
          tenantGroup: productsService.selectedTenantGroup,
          selectedQuote: productsService.selectedQuote,
          clonedPolicy: productsService.clonedPolicy,
          userType: userService.getType(),
          userEmail: userService.getUserEmail(),
          contractRecreationData: productsService.contractRecreationData,
          getTenant: () => ({ id: productsService.tenantId, name: productsService.tenantName }),
          getJourneyId: () => productsService.journeyId,
          clearState: () => productsService.clearJourneyState(),
        };
      },
    };
  },
  deps: [UserService, ProductsService],
};
